/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReportFontCreate } from '../models/ReportFontCreate';
import type { ReportFontUpdate } from '../models/ReportFontUpdate';
import type { ReportFontWithUrl } from '../models/ReportFontWithUrl';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ReportFontsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List Report Fonts
     * @param clusterId
     * @returns ReportFontWithUrl Successful Response
     * @throws ApiError
     */
    public listReportFonts(
        clusterId: string,
    ): CancelablePromise<Array<ReportFontWithUrl>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/report-fonts/list-report-fonts',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Report Font
     * @param clusterId
     * @param requestBody
     * @returns ReportFontWithUrl Successful Response
     * @throws ApiError
     */
    public createReportFont(
        clusterId: string,
        requestBody: ReportFontCreate,
    ): CancelablePromise<ReportFontWithUrl> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/report-fonts/create-report-font',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Report Font
     * @param clusterId
     * @param fontId
     * @param requestBody
     * @returns ReportFontWithUrl Successful Response
     * @throws ApiError
     */
    public updateReportFont(
        clusterId: string,
        fontId: string,
        requestBody: ReportFontUpdate,
    ): CancelablePromise<ReportFontWithUrl> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clusters/{cluster_id}/report-fonts/update-report-font/{font_id}',
            path: {
                'cluster_id': clusterId,
                'font_id': fontId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Report Font
     * @param clusterId
     * @param fontId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteReportFont(
        clusterId: string,
        fontId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clusters/{cluster_id}/report-fonts/delete-report-font/{font_id}',
            path: {
                'cluster_id': clusterId,
                'font_id': fontId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
